export type TEmailReportContainer = {
    tagFilter?: any,
    onClose: Function
}

export enum EEmailReportContainerSubNav {
    performance = "performance",
    activity = "perfactivityormance",
}

export type TEmailReportFilters = {
    search?: string
    timeRange?: string
}